<template>
  <div class="app-container">
    <div class="screeBox">
      <!-- <div class="head"> -->
      <el-select
        filterable
        v-if="userInfo.park_id == 0"
        v-model="screen.park_id"
        placeholder="请选择园区"
        class="screenInput"
        @change="screenParkChange"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        v-model="screen.source"
        placeholder="操作来源"
        class="screenInput"
        @change="sourceChange"
      >
        <el-option label="全部操作来源" value=""></el-option>
        <el-option label="后台" value="admin"></el-option>
        <el-option label="App" value="app"></el-option>
        <el-option label="小程序" value="api"></el-option>
      </el-select>
      <el-select
        filterable
        v-model="screen.user_id"
        placeholder="操作人"
        class="screenInput"
        v-if="screen.source != 2 && screen.source != 3"
      >
        <el-option label="全部操作人" value=""></el-option>
        <template v-for="(item, index) in userList">
          <el-option
            v-if="item.system_role"
            :label="item.system_role.title"
            :value="item.id"
            :key="index"
          ></el-option>
        </template>
      </el-select>
      <el-select
        filterable
        v-model="screen.user_id"
        placeholder="操作人"
        class="screenInput"
        v-else
      >
        <el-option label="全部操作人" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in agoUserList"
          :key="index"
        ></el-option>
      </el-select>
      <!-- <div class="btn"> -->
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
      <!-- </div> -->
      <!-- <el-button
      size="medium"
      type="info"
      circle
      icon="el-icon-refresh"
      style="font-size: 14px; cursor: pointer; float: right"
      @click="fetchData()"
    ></el-button> -->
      <!-- </div> -->
    </div>

    <!-- <div style="margin-top: 20px">
      <el-button
      size="medium"
        type="primary"
        @click="addMenu()"
        v-if="roles.includes('/park/user_add')"
        >添加</el-button
      >
      <el-button
      size="medium"
      type="info"
      @click="downloadFile()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/park/user_import_template')"
      >下载模板</el-button
    >
    <el-button
      size="medium"
      type="success"
      @click="leadIn()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/park/user_import')"
      >导入</el-button
    >
    </div> -->
    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="管理员账号">
        <template slot-scope="scope">
          <span v-if="scope.row.user"> {{ scope.row.user.account }} </span>
        </template>
      </el-table-column>
      <el-table-column label="姓名">
        <template slot-scope="scope">
          <span v-if="scope.row.user"> {{ scope.row.user.name }} </span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column label="操作对象" align="center">
        <template slot-scope="scope">
          <span> {{ scope.row.action_name }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作描述" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.user_park_company_rel.length">
            <span v-for="(item, i) in scope.row.user_park_company_rel" :key="i">
              {{ item.park_name }}
            </span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="操作来源">
        <template slot-scope="scope">
          {{
            scope.row.source == "api"
              ? "小程序"
              : scope.row.source == "admin"
              ? "后台"
              : scope.row.source == "app"
              ? "App"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column label="IP" align="center">
        <template slot-scope="scope">
          {{ scope.row.ip }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="账号类型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "园区" :scope.row.type == 2 ? "企业" : "集团" }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="250"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="roles.includes('/park/user_info')"
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="roles.includes('/park/user_edit')"
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            v-if="roles.includes('/park/user_del')"
            @click="openUserRole(scope.row.id)"
            >查看角色</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/park/user_import'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccessFile"
        :on-progress="beforeAvatarUploadFile"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  logsList,
  editParkUser,
  delParkUser,
  parkUserInfo,
  openPark,
  openRole,
  miniUserRole,
  templatePark_user,
  openAgoUser,
  adminUser,
} from "@/api/index";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加园区",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        source: "",
        user_id: "",
        park_id: "",
      },
      ruleForm: {
        name: "",
        mobile: "",
        address: "",
        bank_name: "",
        bank_code: "",
        lat: "",
        lng: "",
        status: 1,
      },
      rules3: {},
      rules2: {
        password: [
          {
            required: true,
            message: "请输入密码,最少6位",
            trigger: "blur",
            min: 6,
          },
        ],
      },
      rules1: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // password:[{ required: true, message: "请输入密码,最少6位", trigger: "blur",min:6 }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      userRoleVisible: false,
      userRoleData: [],
      roleList: [],
      parkids: [],
      domains: [{ system_role_id: "", park_id: "" }],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
      userList: [],
      agoUserList: [],
    };
  },
  created() {
    if (this.userInfo.is_super != 1) {
      if (this.userInfo.type == 1) {
        this.screen.park_id = this.userInfo.park_id;
      } else if (this.userInfo.type == 2) {
        this.screen.park_id = this.userInfo.park_id;
      }
    } else {
      this.screen.park_id = "";
    }
    this.getUserList();
    this.getPark();
    this.fetchData();
  },
  methods: {
    screenParkChange() {
      this.sourceChange(this.screen.source);
    },
    // 选择操作来源
    sourceChange(e) {
      this.screen.user_id = "";
      if (e == 2 || e == 3) {
        this.getAgoUserList();
      } else {
        this.getUserList();
      }
    },
    getUserList() {
      adminUser({ park_id: this.screen.park_id,is_page:2 }).then((res) => {
        this.userList = res.data.lists;
      });
    },
    getAgoUserList() {
      openAgoUser({ park_id: this.screen.park_id,is_youke:2 }).then((res) => {
        this.agoUserList = res.data.lists.data;
      });
    },
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccessFile(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUploadFile(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      templatePark_user().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    dialogClos() {
      this.parkids = [];
    },
    roleChange(e, index) {
      if (e.length) {
        this.domains[index].system_role_id = e[0];
      } else {
        this.domains[index].system_role_id = "";
      }
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        source: "",
        user_id: "",
        park_id: "",
      };
      if (this.userInfo.is_super != 1) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取角色
    openUserRole(id) {
      var data = {
        user_id: id,
        park_id: this.userInfo.park_id,
        company_id: this.userInfo.company_id,
        source: 1,
      };
      miniUserRole(data).then((res) => {
        this.userRoleData = res.data.lists;
        this.userRoleVisible = true;
      });
    },
    // 获取角色
    getRole(id, index) {
      const data = {
        is_page: 2,
        is_tree: 1,
        role_type: 2,
        type: 1,
        park_id: id || "",
      };
      openRole(data).then((res) => {
        this.$set(this.roleList, index, res.data.lists);
      });
    },
    // 选择园区
    parkChange(id, index) {
      this.parkids = [];
      this.getRole(id, index);
      this.domains[index] = { park_id: id, system_role_id: "" };
      this.domains.forEach((item) => {
        if (item.park_id) {
          this.parkids.push(item.park_id);
        }
      });
    },
    // 添加园区角色
    addDomain() {
      this.domains.push({ park_id: "", system_role_id: "" });
      if (this.userInfo.is_super != 1) {
        this.domains[this.domains.length - 1].park_id = this.userInfo.park_id;
      }
    },
    // 删除园区角色
    removeDomain(index) {
      this.parkids = [];
      var i = this.parkids.findIndex((item) => {
        return item == this.domains[index].park_id;
      });
      if (i != -1) {
        this.parkids.splice(i, 1);
      }
      this.roleList.splice(index, 1);
      this.domains.splice(index, 1);
    },

    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var chone = 0;
          this.domains.forEach((item) => {
            if (item.park_id && item.system_role_id) {
            } else {
              this.$message({
                message: "园区角色未填写完整！",
                type: "warning",
              });
              chone++;
              return;
            }
          });
          if (chone != 0) {
            return;
          }
          this.$confirm("确认提交？")
            .then(() => {
              that.ruleForm.park_role_data = JSON.stringify(that.domains);
              editParkUser(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  if (this.oldImg) {
                  }
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (this.ruleForm.avatar_url) {
        }
        this.ruleForm.avatar_url = res.data.url;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.domains = [];
      this.getInfo(val.id);
      this.oldImg = val.picture;
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.domains = [];
      this.getInfo(val.id);
      this.drawer = true;
    },
    getInfo(id) {
      var that = this;
      var data = {
        id: id,
        park_id: this.userInfo.park_id,
      };
      parkUserInfo(data).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          password: "",
          phone: res.data.info.phone,
          name: res.data.info.name,
          status: res.data.info.status,
          avatar_url: res.data.info.avatar_url,
          sex:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.sex
              : 3,
          education:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.education
              : "",
          cpc:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.cpc
              : 1,
        };
        var list = res.data.info.user_park_company_rel;
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            that.domains.push({
              park_id: list[i].park_id || "",
              system_role_id: list[i].system_role_id,
            });
            if (list[i].park_id) {
              this.parkids.push(list[i].park_id);
            }
            this.getRole(list[i].park_id, i);
          }
        }
      });
    },
    handleDelete(val) {
      const data = {
        id: val.user_id,
        role_id: val.system_role_id,
        park_id: val.park_id,
        company_id: val.company_id,
      };
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delParkUser(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            // that.openUserRole(val.user_id);
            that.userRoleVisible = false;
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClose(done) {
      this.parkids = [];
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch(() => {});
    },
    addMenu() {
      this.drawerTitle = "添加用户";
      this.cztype = "add";
      this.ruleForm = {
        phone: "",
        name: "",
        status: 1,
        park_role_data: "",
        avatar_url: "",
        sex: 3,
        education: "",
        cpc: 2,
        password: "",
      };
      this.domains = [{ park_id: "", system_role_id: "" }];
      if (this.userInfo.is_super != 1) {
        this.domains[0].park_id = this.userInfo.park_id;
        this.getRole(this.userInfo.park_id, 0);
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    delParkUser() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then(() => {
          delParkUser({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      logsList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    display: inline-block;
  }
}

// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 10px 5px 0;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
</style>
